module.exports = __webpack_public_path__ + "img/PY.b7d6b070.png";